export default "__VITE_ASSET__B4_e6XIG__"